import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

import { ResultsPlayerInfo } from '../../models/results/results-player-info';
import { ResultsInfoComponent } from '../results-info/results-info.component';

@Component({
    selector: 'tp-results-info-group',
    templateUrl: './results-info-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, ResultsInfoComponent],
})
export class ResultsInfoGroupComponent {
    @Input() resultsInfos$: Observable<ResultsPlayerInfo[]>;
}
